<template>
  <div>
    <div class="row">
      <div class="col">
        <stats
          :data="data"
        ></stats>
      </div>
    </div>
    <div class="row mt-5">
      <div class="outerBox col-12">
        <div class="innerBox">
          <h5 class="mb-2">Stock By Location</h5>
          <div style="height:300px;" class="w-100" ref="stackedBarAging"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import animated from "@amcharts/amcharts4/themes/animated.js";

import stats from './stats'

am4core.useTheme(animated);

export default {
  props: ['filterUrl'],
  data () {
    return {
      chart : null,
      data : null,
    }
  },
  components : {
    stats
  },
  mounted () {
    this.createChart();
  },
  watch : {
    filterUrl(){
      this.loadData();
    }
  },
  methods: {
    loadData () {
      let length  = this.chart.data.length

      this.$http.get('/api/h1/stock-availability/by-dealer?' + this.filterUrl)
      .then((resp)=>{
        this.data = resp.data.data;
        this.chart.addData(resp.data.data.location , length)
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    createChart () {
      this.chart = am4core.create(this.$refs.stackedBarAging, am4charts.XYChart);

      // Create axes
      let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "name";
      categoryAxis.numberFormatter.numberFormat = "#";
      categoryAxis.renderer.inversed = true;
      categoryAxis.title.text = "Region"
      categoryAxis.renderer.grid.template.location = 0;
    //   categoryAxis.renderer.cellStartLocation = 0.1;
    //   categoryAxis.renderer.cellEndLocation = 0.9;
      categoryAxis.renderer.labels.template.rotation = 0;


      let  valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis()); 
      // valueAxis.renderer.opposite = true;
      valueAxis.title.text = "Number of Stock"

      this.chart.legend = new am4charts.Legend()

      this.createSeries("count", "Number of Stock");

    },
    createSeries (field, name) {
      let series = this.chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = field;
      series.dataFields.categoryX = "name";
      series.name = name;
      series.columns.template.tooltipText = "{name}: [bold]{valueY}[/]";
      series.columns.template.height = am4core.percent(100);
      series.sequencedInterpolation = true;

      let valueLabel = series.bullets.push(new am4charts.LabelBullet());
      // valueLabel.label.text = "{valueY}";
      valueLabel.label.horizontalCenter = "left";
      valueLabel.label.dx = 10;
      valueLabel.label.hideOversized = false;
      valueLabel.label.truncate = false;

      let categoryLabel = series.bullets.push(new am4charts.LabelBullet());
      // categoryLabel.label.text = "{name}";
      categoryLabel.label.horizontalCenter = "right";
      categoryLabel.label.dx = -10;
      categoryLabel.label.fill = am4core.color("#fff");
      categoryLabel.label.hideOversized = false;
      categoryLabel.label.truncate = false;
    }
  }
  
}
</script>